import { toast } from '@webapp/components/Notification'
import { getMessageFromError } from '@webapp/core/utils/errors/getMessageFromError'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useMutateEditApprovalPoolSetting } from '../../models/useMutateEditApprovalPoolSetting'

export const useEditApprovalPoolSettingTogglePresenter = ({
  approvalGroupId,
  onSettingUpdate,
}: {
  approvalGroupId: number
  onSettingUpdate?: () => void
}) => {
  const intl = useProcurifyIntl()

  const { editApprovalPoolSetting } = useMutateEditApprovalPoolSetting()

  const handleApprovalPoolToggleChange = async (value: boolean) => {
    return editApprovalPoolSetting({
      approvalGroupId,
      isPooled: value,
    })
      .then(() => {
        if (value === true) {
          toast.success({
            title: intl.formatMessage(
              messages.approvalPoolsEnabledSuccessTitle
            ),
            children: intl.formatMessage(
              messages.approvalPoolsEnabledSuccessMessage
            ),
          })
        } else {
          toast.success({
            title: intl.formatMessage(
              messages.approvalPoolsDisabledSuccessTitle
            ),
            children: intl.formatMessage(
              messages.approvalPoolsDisabledSuccessMessage
            ),
          })
        }
        onSettingUpdate?.()
      })
      .catch((error) => {
        const errorMessage =
          getMessageFromError(error) ||
          intl.formatMessage(messages.defaultErrorToastMessage)
        toast.error({
          title: 'Error',
          children: errorMessage,
        })
      })
  }

  return {
    commands: {
      handleApprovalPoolToggleChange,
    },
  }
}
